// Lazysizes
import 'lazysizes';

// Components
import "./footer";
import "./modal";
import "./section";
import "./validation";
import "./filtration";
import "./media";
import "./embed";
import "./accordion-search";
import "./map";
import "./zenscroll";
import "./slider";

// aspnet-client-validation bootup

import { ValidationService } from 'aspnet-client-validation';

let v = new ValidationService();
v.bootstrap();